module.exports = __webpack_public_path__ + "static/media/dev_category.74076bb1.png";